/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { CrossChainSwap, CrossChainSwapInterface } from "../CrossChainSwap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dex_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "messageBus",
        type: "address",
      },
    ],
    name: "MessageBusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "dex",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_executor",
        type: "address",
      },
    ],
    name: "executeMessage",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransfer",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_executor",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferFallback",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_executor",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferRefund",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "messageBus",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageBus",
        type: "address",
      },
    ],
    name: "setMessageBus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_dstChainId",
        type: "uint64",
      },
      {
        components: [
          {
            internalType: "address",
            name: "wantToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "bool",
            name: "sendBack",
            type: "bool",
          },
          {
            internalType: "uint32",
            name: "cbrMaxSlippage",
            type: "uint32",
          },
        ],
        internalType: "struct CrossChainSwap.SwapInfo",
        name: "swapInfo",
        type: "tuple",
      },
    ],
    name: "startCrossChainSwap",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CrossChainSwapConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: CrossChainSwapConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class CrossChainSwap__factory extends ContractFactory {
  constructor(...args: CrossChainSwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CrossChainSwap";
  }

  deploy(dex_: string, overrides?: Overrides & { from?: string | Promise<string> }): Promise<CrossChainSwap> {
    return super.deploy(dex_, overrides || {}) as Promise<CrossChainSwap>;
  }
  getDeployTransaction(dex_: string, overrides?: Overrides & { from?: string | Promise<string> }): TransactionRequest {
    return super.getDeployTransaction(dex_, overrides || {});
  }
  attach(address: string): CrossChainSwap {
    return super.attach(address) as CrossChainSwap;
  }
  connect(signer: Signer): CrossChainSwap__factory {
    return super.connect(signer) as CrossChainSwap__factory;
  }
  static readonly contractName: "CrossChainSwap";
  public readonly contractName: "CrossChainSwap";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CrossChainSwapInterface {
    return new utils.Interface(_abi) as CrossChainSwapInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): CrossChainSwap {
    return new Contract(address, _abi, signerOrProvider) as CrossChainSwap;
  }
}
